export default __webpack_public_path__ + "static/media/newSopIcon.59963b85.svg";